export const getAcsUrl = () => {
  const ACS_URL_PATH = '/auth/saml/callback'
  const fronteggDomain = process.env.REACT_APP_FRONTEGG_BASE_URL?.replace(/\/+$/, '')

  return `${fronteggDomain}${ACS_URL_PATH}`
}
